import { render, staticRenderFns } from "./datosCupon.vue?vue&type=template&id=440e9b10&scoped=true"
import script from "./datosCupon.vue?vue&type=script&lang=js"
export * from "./datosCupon.vue?vue&type=script&lang=js"
import style0 from "./datosCupon.vue?vue&type=style&index=0&id=440e9b10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440e9b10",
  null
  
)

export default component.exports